import { Referral } from '@office-start/telemetry-types';
import { oneDriveBusinessUrlRegex, oneDriveConsumerUrlRegex, sharePointUrlRegex, } from './constants';
export function getOtelReferralFromFileLocation(url) {
    if (url && url.length) {
        if (url.match(oneDriveBusinessUrlRegex) ||
            url.match(oneDriveConsumerUrlRegex)) {
            return Referral.Documents;
        }
        if (url.match(sharePointUrlRegex)) {
            return Referral.SharePoint;
        }
    }
    return undefined;
}
//# sourceMappingURL=getOtelReferralFromFileLocation.js.map